import { Injectable } from '@angular/core';
import { AngularFireAuth } from '@angular/fire/auth';
import { AngularFirestore } from '@angular/fire/firestore';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';
import { Observable } from 'rxjs';
import { switchMap, tap } from 'rxjs/operators';
import { map } from 'rxjs/operators';
import { AuthService } from 'src/app/shared/service/auth.service';
import * as firebase from 'firebase';

@Injectable({
  providedIn: 'root',
})
export class AdminGuardService implements CanActivate {
  constructor(
    public router: Router,
    public afAuth: AngularFireAuth,
    private dbstore: AngularFirestore
  ) {}
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ):
    | boolean
    | UrlTree
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree> {
    return this.afAuth.authState.pipe(
      switchMap((user: firebase.User) =>
        this.dbstore
          .collection('super-admin-users', (ref) =>
            ref.where('email', '==', user?.email)
          )
          .get()
          .pipe(
            map((value) => {
             return !!value.docs.find((doc: any) => !!doc.data()?.email);
            })
          )
      )
    );
  }
}
